<template>
	<div class="row slim-grid-row mb-3-1 rounded-6 py-2 bg-white" style="box-shadow: #0000000d 0px 5px 30px 0px">
    <div class="col-3" v-if="use_image">
      <img @click="detail" :src="data.product.data.image_url" class="w-100 rounded-10 w-65px object-fit w-100">
    </div>
    <div :class="{'col-9': use_image, 'col-12': !use_image}">
      <p @click="detail" class="mb-1 body-2 font-bold text-black text-truncate">{{data.variant.length == 1 ? `[${data.variant[0].data.name}] ${data.product.data.name}` : data.product.data.name}}</p>
      <div class="row slim-grid-row">
        <div @click="detail" class="align-self-end" :class="{'col-6': use_image, 'col-8': !use_image}">
          <p class="mb-0 body-2 font-semibold text-truncate" style="line-height: 1 !important;">{{data.product.data.category.name}}</p>
        	<template v-if="data.variant.length > 1">
        		<p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle text-orange mr-1">[{{data.variant.length}}]</p>
        		<p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle">Variants</p>
        	</template>
        	<div class="mb-1" v-else>
	          <p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle text-orange mr-1">[{{data.qty}}x]</p>
	          <p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle">{{ formatCurrency(final_price())}}</p>
        	</div>
      		<p v-if="data.variant.length < 2" class="mb-0 body-3-3 text-truncate" style="line-height: 1 !important;">Note : {{data.product.is_variant ? data.variant[0].notes : data.notes}}</p>
        </div>
        <div class="text-right align-self-end" :class="{'col-6': use_image, 'col-4': !use_image}" v-if="data.variant.length < 2">
          <div class="row" :class="{'no-gutters':use_image}">
            <div class="col-4">
              <div class="pr-1">
                <div class="rounded-4 py-1 box-shadow-cart w-100 bg-orange text-center cursor-pointer" @click="toggleNote(data.product.is_variant?0:null)">
                  <img src="../../../../assets/img/icon/edit-white.png" width="14" style="margin-top:-5px !important">
                </div>
              </div>
            </div>
            <div class="col-8">
              <div class="row rounded-4 py-1 box-shadow-cart text-right w-100 no-gutters">
                <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('minus',data.qty, data.product.is_variant ? data.variant[0].data : false)">
                  <img src="../../../../assets/img/icon/minus-orange.png" width="14">
                </div>
                <div class="col-4 text-center">
                  <p class="mb-0 body-2-4 position-relative" style="top: 3px;">{{data.qty}}</p>
                </div>
                <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('plus',data.qty, data.product.is_variant ? data.variant[0].data : false)">
                  <img src="../../../../assets/img/icon/plus-orange.png" width="14">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.variant.length > 1" class="col-12 mt-2 border-top">
    	<div class="px-2" v-for="(variant,index) in data.variant">
    		<div class="row pt-2">
    			<div @click="detail" class="align-self-center col-8">
		    		<p class="mb-0 body-2 font-bold text-black text-truncate" style="line-height: 1 !important;">{{variant.data.name}}</p>
		    		<p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle text-orange mr-1">[{{variant.qty}}x]</p>
		        <p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle mb-1">{{ formatCurrency(final_price(false,variant.data.price))}}</p>
            <p class="mb-0 body-3-3 text-truncate" style="line-height: 1 !important;">Note : {{variant.notes}}</p>
    			</div>
    			<div class="align-self-center col-4">
            <div class="row">
              <div class="col-4">
                <div class="pr-1">
                  <div class="rounded-4 py-1 box-shadow-cart w-100 bg-orange text-center cursor-pointer" @click="toggleNote(index)">
                    <img src="../../../../assets/img/icon/edit-white.png" width="14" style="margin-top:-5px !important">
                  </div>
                </div>
              </div>
              <div class="col-8">
        				<div class="row rounded-4 py-1 box-shadow-cart text-right w-100 no-gutters">
    	            <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('minus',variant.qty, variant.data)">
    	              <img src="../../../../assets/img/icon/minus-orange.png" width="14">
    	            </div>
    	            <div class="col-4 text-center">
    	              <p class="mb-0 body-2-4 position-relative" style="top: 3px;">{{variant.qty}}</p>
    	            </div>
    	            <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('plus',variant.qty, variant.data)">
    	              <img src="../../../../assets/img/icon/plus-orange.png" width="14">
    	            </div>
    	          </div>
              </div>
            </div>
    			</div>
    			<div class="col-12 mt-2" v-if="index+1 != data.variant.length">
    				<div class="w-100 d-block border-light-bottom"></div>
    			</div>
    		</div>
    	</div>
    </div>

    <!-- Product Note -->
    <PopupInputNote 
      v-if="is_note" 
      :title="note_title"
      :data="note_vuex.notes"
      @cancel="toggleNote" 
      @submit="submitNote"></PopupInputNote>
  </div>
</template>
<script>
	import {formatCurrency} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex';
  import PopupInputNote from '@/components/hotel/concierge/general/PopupInputNote'

  export default{
    components:{
      PopupInputNote
    },
  	props:{
      data:{
        type: Object,
        default: () => {}
      },
      use_image:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        is_note: false,
        note_title: '',
        note_vuex: {
          product_id: '',
          variant_id: '',
          notes: ''
        }
      }
    },
    computed:{
      is_variant(){
        return this.data.variant.length == 0 ? false : true
      },
      base_price(){
        return this.is_variant ? this.data.variant[0].data.price : this.data.product.data.price
      }
    },
  	methods:{
  		...mapMutations(['setConciergeOrder','removeConciergeOrder','setConciergeOrderNote']),
  		formatCurrency(value){
        return formatCurrency(value);
      },
      final_price(is_default=true,variant_price){
        let price =  0
        if(is_default){
          price = this.base_price
        }else{
          price = variant_price
        }

        let total = price.price_sell_final_with_tax_service
        if(price.promotion_amount > 0 && price.promotion_type == 'INCREASE'){
          total += price.promotion_amount
        }
        return total
      },
      detail(){
        if(this.use_image){
          this.$emit('detail',this.data.product.data)
        }
      },
      changeQtyProduct(type,qty,variant=false){
      	let params = {
          product: this.data.product.data,
          variant: variant == false ? {} : variant,
          qty: qty
        }
      	if(type == 'minus' && qty == 1){
      			this.removeConciergeOrder(params)
      	}else{
      		if(type == 'minus'){
            params.qty--
          }else{
            params.qty++
          }
          this.setConciergeOrder(params)
      	}
      },
      toggleNote(variant_index=null){
        this.is_note = !this.is_note
        if(this.is_note){
          this.note_title = this.data.product.is_variant ? `[${this.data.variant[variant_index].data.name}] ${this.data.product.data.name}` : this.data.product.data.name
          this.note_vuex = {
            product_id: this.data.product.data.id,
            variant_id: variant_index == null ? '' : this.data.variant[variant_index].data.id,
            notes: variant_index == null ? this.data.notes : this.data.variant[variant_index].notes
          }   
        }else{
          this.note_title = ''
          this.note_vuex = {
            product_id: '',
            variant_id: '',
            notes: ''
          }
        }
      },
      submitNote(notes){
        this.note_vuex.notes = notes
        this.setConciergeOrderNote(this.note_vuex)
        this.toggleNote()
      }
  	}
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuCart.vue